// extracted by mini-css-extract-plugin
module.exports = {"store":"StoreRowWithRank_store__2YmQf","rank-and-new":"StoreRowWithRank_rank-and-new__W9-vH","rank":"StoreRowWithRank_rank__1CP_f"};